import {
  calculateYeastVolumeForAllUnits,
  onGravityChange,
  onPitchRateChange,
} from './calculation-helper';
import { Action, ActionKind, IPitchState } from './types';

export const reducer = (state: IPitchState, action: Action): IPitchState => {
  switch (action.type) {
    case ActionKind.SetViability:
      return { ...state, viability: action.payload };

    case ActionKind.SetConcentration:
      return { ...state, concentration: action.payload };

    case ActionKind.SetWort:
      return { ...state, wort: action.payload };

    case ActionKind.ChangeWortVolumeUnit:
      return { ...state, wortUnit: action.payload };

    case ActionKind.ChangePlotGravity:
      return { ...state, gravityType: action.payload };

    case ActionKind.ChangeCalculationMethod:
      return { ...state, calculationMethod: action.payload };

    case ActionKind.SetTargetConcentration:
      return {
        ...state,
        gravity: undefined,
        pitchRate: undefined,
        targetConcentration: action.payload,
      };

    case ActionKind.Calculate:
      return { ...state, yeastVolume: calculateYeastVolumeForAllUnits(state) };

    case ActionKind.SetGravity:
      return onGravityChange({ state, gravity: action.payload });

    case ActionKind.SetPitchRate:
      return onPitchRateChange({ state, pitchRate: action.payload });

    case ActionKind.Reset:
      return {
        ...state,
        wort: undefined,
        gravity: undefined,
        pitchRate: undefined,
        yeastVolume: undefined,
        targetConcentration: undefined,
      };

    default:
      return { ...state };
  }
};
